module.exports = __webpack_public_path__ + "img/icons-40-perks-why-so-serious.3fcb5f5f.svg";